// Κοινά κομμάτια των κινήσεων ταμείου: εικονίδιο και χρώμα ανά είδος.

import React from 'react';
import { ArrowDownToLine, ArrowUpFromLine, Receipt } from 'lucide-react';
import type { CashMovementKind } from '../../../types/registerReport';

const ICONS: Record<CashMovementKind, React.ElementType> = {
  expense: Receipt,
  withdrawal: ArrowUpFromLine,
  deposit: ArrowDownToLine,
};

export function KindIcon({ kind, className }: { kind: CashMovementKind; className?: string }) {
  const Icon = ICONS[kind] || Receipt;
  return <Icon className={className} aria-hidden />;
}

/** Βγαίνουν από το συρτάρι: κόκκινο/πορτοκαλί· μπαίνουν: πράσινο. */
export const KIND_TONE: Record<CashMovementKind, { selected: string; badge: string; amount: string; tile: string }> = {
  expense: {
    selected: 'border-rose-600 bg-rose-600/10 text-rose-700 dark:border-rose-400 dark:text-rose-300',
    badge: 'bg-rose-500/10 text-rose-700 dark:text-rose-300',
    amount: 'text-rose-700 dark:text-rose-300',
    tile: 'bg-rose-500/10 text-rose-600 dark:text-rose-300',
  },
  withdrawal: {
    selected: 'border-amber-600 bg-amber-500/10 text-amber-800 dark:border-amber-400 dark:text-amber-300',
    badge: 'bg-amber-500/15 text-amber-800 dark:text-amber-300',
    amount: 'text-amber-800 dark:text-amber-300',
    tile: 'bg-amber-500/15 text-amber-700 dark:text-amber-300',
  },
  deposit: {
    selected: 'border-emerald-600 bg-emerald-600/10 text-emerald-700 dark:border-emerald-400 dark:text-emerald-300',
    badge: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-300',
    amount: 'text-emerald-700 dark:text-emerald-300',
    tile: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-300',
  },
};
